// Session 58 · Single source of truth for the "Primary location" dropdown
// used on signup + profile editor. Matches server.py::_STATE_ABBR_TO_NAME
// canonical names so venue/state filters line up server-side.

export const US_LOCATIONS = [
  "Washington, DC",
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho",
  "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine",
  "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
  "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
  "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia",
  "Washington", "West Virginia", "Wisconsin", "Wyoming",
];

// Sentinel value used to trigger the "outside US → free-text country" flow
// in <select> options across the app.
export const OTHER_LOCATION = "__other__";

// True when `value` is one of the recognized US locations (used to decide
// whether the profile editor should default to the state dropdown or the
// country input for a saved profile).
export function isUsLocation(value) {
  return typeof value === "string" && US_LOCATIONS.includes(value);
}
